import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Box, Toolbar } from "@mui/material";
import { useClientAuth } from "./hooks/useClientAuth";
import PortalNavbar from "./components/PortalNavbar";
import ModuleGuard from "./components/ModuleGuard";

import PortalDashboard_View from "./Views/PortalDashboard_View";

// ══════════════════════════════════════════════════════════════════════════
// Importare qui i controller dei moduli man mano che vengono implementati:
// import PortalPrezzi_Controller from "./Controllers/Modules/Prezzi/PortalPrezzi_Controller";
// import PortalForecast_Controller from "./Controllers/Modules/Forecast/PortalForecast_Controller";
// ══════════════════════════════════════════════════════════════════════════

export default function AppLayout() {
  const { clientData, loading, logout } = useClientAuth();

  if (loading) return null;
  if (!clientData) return <Navigate to="/login" replace />;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <PortalNavbar clientData={clientData} onLogout={logout} />
      <Toolbar /> {/* spacer per l'AppBar fixed */}

      <Box sx={{ flexGrow: 1, bgcolor: "background.default" }}>
        <Routes>
          <Route path="/dashboard" element={<PortalDashboard_View clientData={clientData} />} />

          {/* ══ Aggiungere qui le route dei moduli ══
          <Route
            path="/prezzi"
            element={
              <ModuleGuard moduleKey="prezzi">
                <PortalPrezzi_Controller />
              </ModuleGuard>
            }
          />
          ══════════════════════════════════════════ */}

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Box>
    </Box>
  );
}
